import React from 'react';
import { useFormContext } from 'react-hook-form';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { createAction } from 'utils';

import CustomSwitchButton from 'components/base/CustomSwitchButton';
import CustomTitleWithInput from 'components/base/CustomTitleWithInput';
import { hasError } from 'components/base/ErrorFieldMessage';
import ContentSections from 'components/base/ContentSections';
import { SaveAndBackButtons } from 'components/base/BottomStepComponent';
import { listItem } from 'components/banners/DisplayItems';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import InputFieldControl from 'components/base/InputFieldControl';

import './CreateLevelDiscountContent.scss';
import LevelBenefits from './LevelBenefits';
import { LanguageConfig, hideLevelDiscount } from 'config/CustomEnums';

function LevelDiscountContent({
  language,
}) {
  const {
    formState: { errors },
    setValue,
    watch,
  } = useFormContext();

  const discountNumberFieldName = "discountNumber"
  const isFreeDeliveryOnShopifyFieldName = "freeDeliveryOnShopfify"

  const watchSourceName = watch('sourceName');
  const watchDiscount = watch(discountNumberFieldName);
  const watchIsFreeDeliveryOnShopify = watch(isFreeDeliveryOnShopifyFieldName);

  if (language !== LanguageConfig.english) {
    return null;
  };

  return (
    <>
      <label className="create-section-title">General</label>

      {listItem(
        'Name',
        watchSourceName,
      )}

      {
        hideLevelDiscount
          ? null
          : <>
            <InputFieldControl
              name={discountNumberFieldName}
              title={'Discount'}
              style={{ width: 'auto' }}
              type="number"
              value={watchDiscount}
              setValue={(value) => {
                setValue(discountNumberFieldName, value, { shouldDirty: true });
              }}
              error={
                hasError(errors, discountNumberFieldName)
                  ? {
                      id: discountNumberFieldName,
                      error: hasError(errors, discountNumberFieldName),
                      message: 'Please provide required/valid quantity.',
                    }
                  : null
              }
              customClass={'level-discount-input'}
              unit={'%'}
              min={1}
              max={100}
            />
            <CustomTitleLabel title="Shopify - free delivery" />
            <CustomSwitchButton
              defaultChecked={watchIsFreeDeliveryOnShopify || false}
              onChange={(isChecked) => {
                setValue(isFreeDeliveryOnShopifyFieldName, isChecked, { shouldDirty: true });
              }}
            />
          </>
      }
    </>
  );
}

const CreateLevelDiscountContent = ({
  languages,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { getValues, setError, clearErrors } = useFormContext();
  const validate = async () => {
    clearErrors(['discountNumber']);
    const [discountNumber] = getValues(['discountNumber']);
    let isError = false;

    if (
      !discountNumber
      || Number(discountNumber) <= 0
      || Number(discountNumber) > 100
    ) {
      isError = true;
      setError(
        'discountNumber',
        {
          type: 'require',
          message: 'Please provide required/valid quantity.',
        },
        { shouldFocus: true },
      );
    }
    return !isError;
  };

  const getTabs = (language) => {
    const tabs = [
      <LevelDiscountContent
        language={language}
      />,
      <LevelBenefits
        language={language}
      />,
    ];
    return tabs;
  };


  return (
    <>
      <ContentSections
        languageTabContent={{
          containers: languages?.map((item) => ({
            container: getTabs(item.code),
            key: item.code,
            title: item.sourceName,
          })),
        }}
        hidePreview
      />
      <SaveAndBackButtons
        saveText={'Save'}
        backAction={() => history.goBack()}
        saveAction={async () => {
          const isValid = await validate();
          if (isValid) {
            dispatch(createAction('levelDiscount/createOrUpdate')(getValues()));
          }
        }}
      />
    </>
  );
}

const mapPropsToState = (state) => ({
  languages: state.language.allList,
})

export default connect(mapPropsToState)(CreateLevelDiscountContent);
